export default __webpack_public_path__ + "static/media/background.cf7eb9e2.jpg";